import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Avatar from 'flarum/common/components/Avatar';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Placeholder from 'flarum/common/components/Placeholder';
import username from 'flarum/common/helpers/username';
import { nextBirthday } from '../../common/utils/birthday';
export default class BirthdayList extends Component {
  view() {
    const state = this.attrs.state;
    if (state.isEmpty()) {
      return m("div", {
        className: "BirthdayList"
      }, m(Placeholder, {
        text: app.translator.trans('datlechin-birthdays.forum.page.empty_text')
      }));
    }
    const today = dayjs().startOf('day');
    const isLoading = state.isInitialLoading() || state.isLoadingNext();
    return m("div", {
      className: "BirthdayList"
    }, m("div", {
      className: "BirthdayList-days"
    }, this.days(today).map(([date, users]) => m("section", {
      key: date.format('YYYY-MM-DD'),
      className: "BirthdayList-day"
    }, m("h3", {
      className: "BirthdayList-date"
    }, this.dateLabel(date, today)), m("ul", {
      className: "BirthdayList-users"
    }, users.map(user => m("li", {
      key: user.id()
    }, this.userItem(user, date.isSame(today, 'day')))))))), m("div", {
      className: "BirthdayList-loadMore"
    }, isLoading ? m(LoadingIndicator, null) : state.hasNext() && m(Button, {
      className: "Button",
      onclick: state.loadNext.bind(state)
    }, app.translator.trans('datlechin-birthdays.forum.page.load_more_button'))));
  }
  days(today) {
    const days = new Map();
    this.attrs.state.getPages().forEach(page => page.items.forEach(user => {
      const monthDay = user.birthMonthDay();
      if (!monthDay) return;
      const date = nextBirthday(monthDay, today);
      const key = date.format('YYYY-MM-DD');
      if (!days.has(key)) days.set(key, [date, []]);
      days.get(key)[1].push(user);
    }));
    return [...days.values()];
  }
  dateLabel(date, today) {
    if (date.isSame(today, 'day')) return app.translator.trans('datlechin-birthdays.forum.page.today_heading');
    if (date.isSame(today.add(1, 'day'), 'day')) return app.translator.trans('datlechin-birthdays.forum.page.tomorrow_heading');
    return app.translator.formatDateTime(date, 'datlechin-birthdays.lib.datetime_formats.day');
  }
  userItem(user, isToday) {
    const age = user.age();
    return m(Link, {
      href: app.route.user(user),
      className: "BirthdayList-user"
    }, m(Avatar, {
      user: user
    }), m("span", {
      className: "BirthdayList-username"
    }, username(user)), age !== undefined && m("span", {
      className: "BirthdayList-age"
    }, app.translator.trans('datlechin-birthdays.forum.page.turns_text', {
      age: isToday ? age : age + 1
    })));
  }
}
flarum.reg.add('datlechin-birthdays', 'forum/components/BirthdayList', BirthdayList);